import { all_routes } from "../../../feature-module/router/all_routes";
import {
  is_manager,
  is_exclusions,
  skip_manager,
  is_hod,
  manager_pms,
  isSupportteam,
  isMasterLogin,
  can_raise_recruitment,
  IsNewEmployee,
} from "../../../environment";
const routes = all_routes;
import("../../../style/icon/themify/themify.css");

const allowedPmsEmployees = ["T1-9093", "T1-9080", "T1-9030", "T1-9125"];
const employee_id = localStorage.getItem("employee_id") || "";
const isExcludedApprisal =
  localStorage.getItem("is_excluded_apprisal") === "true";
// const canShowSubMenu = allowedPmsEmployees.includes(employee_id);

export const SidebarDataTest = [
  {
    tittle: "",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        materialicons: "confirmation_number",
        label: "Dashboard",
        link: routes.employeeDashboard,
        submenu: false,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        submenuItems: [],
      },

      // Company Overview
      {
        label: "Company Overview",
        // link: routes.leaveadmin,
        submenu: true,
        showSubRoute: false,
        icon: "building",
        base: "out-duty",
        materialicons: "directions_walk",
        submenuItems: [
          {
            label: "Company Overview ",
            link: routes.organisation,
            base: "asset-list",
          },
          {
            label: "Organization Structure",
            link: routes.organisationstructure,
            base: "asset-categories",
          },
          ,
          {
            label: "Holiday Calendar",
            link: routes.holidays,
            base: "asset-categories",
          },
          ,
          {
            label: "Policies",
            link: routes.privacyPolicy,
            base: "asset-categories",
          },
          ,
          {
            label: "Standard Procedures",
            link: routes.sops,
            base: "asset-categories",
          },
        ],
      },

      // Employee Resources
      {
        label: "Employee Resources",
        // link: routes.leaveadmin,
        submenu: true,
        showSubRoute: false,
        // icon: "briefcase-2",
        icon: "briefcase-2",
        base: "out-duty",
        materialicons: "directions_walk",
        submenuItems: [
          {
            label: "Employee Directory",
            link: routes.employeedirectory,
            base: "employee-directory",
          },
          {
            label: "Digital Credentials",
            base: "digital-assets",
            submenu: true,
            showSubRoute: false,
            icon: "calendar-minus",
            materialicons: "event_busy",
            submenuItems: [
              {
                label: "Logos",
                link: "/digital-assets/logos",
                base: "logos",
                showSubRoute: false,
              },
              {
                label: "Screensaver",
                link: "/digital-assets/screensaver",
                base: "screensaver",
                showSubRoute: false,
              },
              {
                label: "Presentation Template",
                link: "/digital-assets/presentation-template",
                base: "presentation-template",
                showSubRoute: false,
              },
              {
                label: "Other Documents",
                link: "/digital-assets/other-documents",
                base: "other-documents",
                showSubRoute: false,
              },
              {
                label: "Email Signature",
                link: "/digital-assets/email-signature",
                base: "email-signature",
                showSubRoute: false,
              },
            ],
          },

          {
            label: "Benefits & Insurance",
            link: routes.insurance,
            base: "insurance",
          },
          {
            label: "Help Centre",
            link: routes.selfhelp,
            base: "self-help",
          },
          {
            label: "E-Library",
            link: routes.elibrary,
            base: "elibrary",
          },
          {
            label: "Compensation",
            link: routes.compensationPage,
            base: "compensation",
          },
          {
            label: "Pay Slip",
            link: routes.employeePayslip,
            base: "payslip",
          },
        ],
      },

      // Work & Operations
      {
        label: "Work & Operations",
        submenu: true,
        showSubRoute: false,
        icon: "tool",
        base: "work-operations",
        materialicons: "work",
        submenuItems: [
          {
            label: "Leave",
            submenu: true,
            base: "leave",
            showSubRoute: false,
            submenuItems: [
              {
                label: "Self Leave",
                link: routes.seflGrid,
                base: "leave-application",
              },
              ...(is_manager === "true"
                ? [
                    {
                      label: "Team Leave",
                      link: routes.teamGrid,
                      customSubmenuTwo: true,
                      submenu: true,
                      showSubRoute: false,
                      base: "leaves",
                    },
                  ]
                : []),
            ],
          },
          {
            label: "Attendance",
            submenu: true,
            base: "leave",
            showSubRoute: false,
            submenuItems: [
              {
                label: "Self Attendance",
                link: routes.attendanceGrid,
                base: "leave-application",
              },
              ...(is_manager === "true"
                ? [
                    {
                      label: "Team Attendance",
                      link: routes.attendanceTeamDashboard,
                      customSubmenuTwo: true,
                      submenu: true,
                      showSubRoute: false,
                      base: "leaves",
                    },
                  ]
                : []),
            ],
          },
          {
            label: "Out Duty",
            submenu: true,
            base: "leave",
            showSubRoute: false,
            submenuItems: [
              {
                label: "Self Out Duty",
                link: routes.selfOutDutyGrid,
                base: "leave-application",
              },
              ...(is_manager === "true"
                ? [
                    {
                      label: "Team Out Duty",
                      link: routes.teamOutDutyGrid,
                      customSubmenuTwo: true,
                      submenu: true,
                      showSubRoute: false,
                      base: "leaves",
                    },
                  ]
                : []),
            ],
          },
          {
            label: "PMS",
            submenu: true,
            base: "leave",
            showSubRoute: false,
            submenuItems: [
              ...(is_exclusions !== "1"
                ? [
                    {
                      label: "Goal Settings",
                      link: routes.pmsGrid,
                      base: "leave-application",
                    },
                    {
                      label: "User Guide",
                      link: routes.userguide,
                      base: "leave-application",
                    },
                  ]
                : []),
              {
                label: "Appraisal Letter",
                link: routes.appraisalLetter,
                base: "leave-application",
              },
              ...(isExcludedApprisal
                ? []
                : [
                    {
                      label: "Appraisal for Self",
                      link: routes.pmsReview,
                      base: "leave-application",
                    },
                  ]),
              ...(manager_pms === "true"
                ? [
                    {
                      label: "Manager Appraisal",
                      link: routes.pmsAllEmployeeR1,
                      base: "leave-application",
                    },
                  ]
                : []),
              ...(skip_manager === "true"
                ? [
                    {
                      label: "Skip Manager Appraisal",
                      link: routes.pmsAllEmployeeR2,
                      base: "leave-application",
                    },
                  ]
                : []),
              ...(is_hod === "true"
                ? [
                    {
                      label: "Appraisal HOD",
                      link: routes.pmsAllEmployeeHod,
                      base: "leave-application",
                    },
                  ]
                : []),
            ],
          },
          {
            label: "Monthly Feedback",
            submenu: true,
            showSubRoute: false,
            icon: "chalkboard",
            base: "career-support",
            materialicons: "directions_walk",
            submenuItems: [
              {
                label: "Self Feedback",
                link: routes.selfmonthlyfeedback,
                base: "employee-view",
              },
              ...(is_manager === "true"
                ? [
                    {
                      label: "Team Feedback",
                      link: routes.teammonthlyfeedback,
                      base: "manager-view",
                    },
                  ]
                : []),
            ],
          },
          {
            label: "Expense",
            link: routes.travell,
            submenu: false,
            showSubRoute: false,
            icon: "file-invoice",
            base: "travel-requests",
            materialicons: "flight",
            submenuItems: [],
          },
          {
            label: "Engagement Activities",
            link: routes.engagementcalendar,
            base: "engagement",
            submenu: false,
            showSubRoute: false,
          },
          {
            label: "Assets",
            link: routes.assetList,
            base: "assets",
            submenu: false,
            showSubRoute: false,
          },
          {
            label: "Team1Enrich",
            submenu: true,
            showSubRoute: false,
            icon: "chalkboard",
            base: "career-support",
            materialicons: "directions_walk",
            submenuItems: [
              {
                label: "Training Calender",
                link: routes.employeeTraningList,
                base: "employee-traning-list",
              },
              {
                label: "My Nominations",
                link: routes.employeeView,
                base: "employee-view",
              },
              {
                label: "Assessments",
                link: routes.assessment,
                base: "employee-view",
              },
              ...(is_manager === "true"
                ? [
                    {
                      label: "Team Nominations",
                      link: routes.manager,
                      base: "manager-view",
                    },
                  ]
                : []),
            ],
          },
          {
            label: "Offboarding",
            submenu: true,
            showSubRoute: true,
            icon: "chalkboard",
            base: "career-support",
            materialicons: "directions_walk",
            submenuItems: [
              {
                label: "Application",
                link: routes.selfOffboarding,
                base: "employee-view",
              },

              ...(is_manager === "true"
                ? [
                    {
                      label: "Approval",
                      link: routes.teamoffboarding,
                      base: "manager-view",
                    },
                  ]
                : []),
              ...(isSupportteam === "true"
                ? [
                    {
                      label: "Clearance",
                      link: routes.teamClearance,
                      base: "manager-view",
                    },
                  ]
                : []),
            ],
          },
          ...(can_raise_recruitment === "true"
            ? [
                {
                  label: "Recruitment",
                  submenu: false,
                  base: "recruitment",
                  showSubRoute: false,
                  link: routes.RecruitmentDashboard,
                },
              ]
            : []),
        ],
      },

      // Communication & Culture
      {
        label: "Communication & Culture",
        submenu: true,
        showSubRoute: false,
        icon: "message",
        base: "out-duty",
        materialicons: "directions_walk",
        submenuItems: [
          {
            label: "Announcements ",
            link: routes.announcements,
            base: "notice-circulars",
          },
          {
            label: "Notice Circulars ",
            link: routes.noticecirculars,
            base: "notice-circulars",
          },
          {
            label: "Appreciation Wall",
            link: routes.recognition,
            base: "recognition",
          },
          ,
          {
            label: "Team Chat",
            link: routes.wetalk,
            base: "we-talk",
          },
          ,
          {
            label: "Gallery",
            link: routes.gallery,
            base: "gallery",
          },
          {
            label: "Survey/Polls",
            link: routes.surveypolls,
            base: "Survey",
          },
        ],
      },

      // Probation Assessment
      {
        materialicons: "confirmation_number",
        label: "Assessment Forms",
        // link: routes.managerEnabledProbationAssessment,
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "assessment-form",
        submenuItems: [
          ...(IsNewEmployee == "true"
            ? [
                {
                  label: "Buddy Feedback Form",
                  link: `${routes.buddyFeedbackForm}`,
                  base: "assessment-form",
                },
                {
                  label: "Monthly Feedback Form",
                  link: `${routes.managerEnabledMonthlyAssessment}`,
                  // link: `${routes.employeeAssessmentForms}/monthly`,
                  base: "assessment-form",
                },
                {
                  label: "Induction Feedback Form",
                  link: `${routes.inductionFeedbackForm}`,
                  base: "assessment-form",
                },
              ]
            : [
                {
                  label: "Probation Assessment",
                  link: routes.managerEnabledProbationAssessment,
                  base: "assessment-form",
                },
              ]),
        ],
      },

      // Career & Support
      {
        label: "Career & Support",
        submenu: true,
        showSubRoute: false,
        icon: "trending-up",
        base: "career-support",
        materialicons: "directions_walk",
        submenuItems: [
          {
            label: "Open Positions (Jobs)",
            base: "open-positions",
            submenu: true,
            showSubRoute: false,
            icon: "calendar-minus",
            materialicons: "event_busy",
            submenuItems: [
              {
                label: "All Jobs",
                link: routes.jobgrid,
                base: "asset-list",
              },
              {
                label: "My Job Referrals",
                link: routes.refferal,
                base: "asset-categories",
              },
            ],
          },
          {
            label: "Support Team",
            link: routes.supportteam,
            base: "support-team",
          },
          {
            label: "FAQs",
            link: "https://team1consulting.tawk.help/",
            submenu: false,
            showSubRoute: false,
            icon: "info-circle",
            base: "faqs",
            materialicons: "help_outline",
            submenuItems: [],
            target: "_blank",
          },
        ],
      },
      // TimeSheet Management
      {
        label: "Timesheet",
        link: "job",
        submenu: true,
        showSubRoute: false,
        icon: "clock",
        base: "timesheet",
        materialicons: "access_time",
        submenuItems: [
          ...(is_manager === "true"
            ? [
                {
                  label: "Projects",
                  link: routes.projectlist,
                  base: "asset-list",
                },
                {
                  label: "Team Tasks",
                  link: routes.tasks,
                  base: "asset-categories",
                },
              ]
            : []),

          {
            label: "Tasks",
            link: routes.timesheet,
            base: "asset-categories",
          },
          {
            label: "Time log",
            link: routes.timeLogs,
            base: "asset-categories",
          },
        ],
      },
    ],
  },
];
